<template>
	<loading-panel v-if="isLoading && !discussion" is-loading="true" class="my-3"/>
  	<div v-else-if="discussion">
		<div class="pt-4 px-4">
			<div class="alert alert-danger d-inline-block" v-if="discussion_opened">
				<span class="far fa-comment-alt-exclamation fa-fw"></span> Обсуждение открыто
			</div>
			<div class="alert alert-light border d-inline-block" v-else-if="!discussion_opened">
				<div v-if="!discussion.length">
					<span class="far fa-comment-alt fa-fw"></span> Обсуждение не начато
				</div>
				<div v-else>
					<span class="far fa-comment-alt-check fa-fw"></span> Обсуждение закрыто
				</div>
			</div>
	  		<transition-group name="fade">
				<div v-for="message in discussion" :key="message.id">
		  			<discussion-message
					:message="message"
					v-on:discussionDeleted="$emit('refetch'); fetchData();"
					v-on:discussionUpdated="$emit('refetch'); fetchData();"
		  			/>
				</div>
	  		</transition-group>
		</div>
		<div class="card-footer pt-4 bg-light">
			<div class="row">
				<div class="col-12 col-md-6">
				  	<div class="mb-2 border">
						<ckeditor :editor="editor" v-model="newMessage" :disabled="isUploading" :config="editorConfig" ></ckeditor>
					</div>

					<div class="pt-2 d-flex justify-content-between">
						<b-button @click="sendComment" class="mr-auto" variant="primary" size="sm" :disabled="isUploading || !sendable">
							<span v-if="!isUploading" class="far fa-envelope fa-fw"></span> 
							<span v-else-if="isUploading" class="far fa-spinner-third fa-spin fa-fw"></span> 
							Отправить
						</b-button>
						<b-form-checkbox
						v-if="enable_discussions_change_status"
						v-model="newDiscussionStatus"
						:value="1"
						unchecked-value="0"
						:disabled="isLoading || isUploading"
						>
							<span v-if="discussion_opened">Закрыть обсуждение</span>
							<span v-else>Открыть обсуждение</span>
						</b-form-checkbox>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Vue from 'vue'
import moment from 'moment'
export default {
	props: [],
	filters: {
	},
	data: function () {
		return {
			moment: moment,
			isUploading: false,
			isLoading: false,
			discussion: undefined,
			discussion_opened: undefined,
			enable_discussions_answer: false,
			enable_discussions_change_status: false,
			id: null,
			newMessage: '',
			newDiscussionStatus: null,
			editor: ClassicEditor,
			editorConfig: {
				language: 'ru',
				rows: 3,
				placeholder: 'Введите сообщение',
				toolbar: [ 'heading', 'bold', 'italic', '|', 'numberedList', 'bulletedList', '|', 'link', '|', 'undo', 'redo' ]
			}
		}
	},
	mounted: function () {
		this.id = this.$route.params.id
		this.fetchData()
	},
	methods: {
		fetchData () {
			if (this.isLoading) {
			  return false
			}
			this.isLoading = true

			this
				.$http
				.get(this.discussionUrl)
				.then(response => {
					this.discussion = response.data.discussion
					this.discussion_opened = response.data.discussion_opened
					this.enable_discussions_answer = response.data.enable_discussions_answer
					this.enable_discussions_change_status = response.data.enable_discussions_change_status
				})
				.catch(error => {
					this.$notify({
						group: 'main',
						text: 'Ошибка получения',
						duration: 5000,
						type: 'alert-danger'
					})
				})
				.finally(() => {
					this.isLoading = false
				})
		},
		sendComment () {
			if (this.isUploading) {
				return false
			}
			this.isUploading = true

			let data = {
				'message': this.newMessage,
			}

			if (this.newDiscussionStatus) {
				if (this.discussion_opened) {
					data['do_close_discussion'] = 1
				} else {
					data['do_open_discussion'] = 1
				}
			}

			this
				.$http
				.post(this.discussionUrl, data)
				.then(response => {
					this.discussion = response.data.discussion
					this.discussion_opened = response.data.discussion_opened
					this.enable_discussions_answer = response.data.enable_discussions_answer
					this.newMessage = ''
					this.newDiscussionStatus = null
					this.$notify({
					  group: 'main',
					  text: response.data.status ? response.data.status : '',
					  duration: 5000,
					  type: 'alert-success'
					})
				  	this.$emit('refetch')
				})
				.catch(error => {
					this.$notify({
						group: 'main',
						text: 'Ошибка ' + error.response.data.error,
						duration: 5000,
						type: 'alert-danger'
					})
				})
				.finally(() => {
					this.isUploading = false
				})
		}
	},
	computed: {
		profile () {
			return this.$store.getters.profile
		},
		breadcrumbs () {
			return [{
				text: 'Решения по проекту',
				to: '/projects_other'
			}, {
				text: (this.id ? 'Проект ' + this.id : '...'),
				to: '/projects_other/' + this.id
			}, {
				text: 'Обсуждение',
				active: true
			}]
		},
		sendable () {
			if (this.newMessage || this.newDiscussionStatus) {
				return true
			} else {
				return false
			}
		},
		discussionUrl () {
			return process.env.VUE_APP_API_ROOT + '/api/projects_other/' + this.id + '/discussion'
		}
	},
	watch: {
		'$route.params.id': function (id) {
			this.id = id
			this.fetchData(id)
		}
	}
}
</script>